import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizeArchivedFiles = data => {
  const file = new schema.Entity('files')
  return normalize(data, [file])
}

const ArchivedFilesReducer = combineReducers({
  fetchArchivedFilesRequest: createRequestReducer('ARCHIVED_FILES:FETCH'),
  files: createReducer(null, {
    'ARCHIVED_FILES:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizeArchivedFiles(
        response.data.account.teacher_type.archived_assessment_files
      ),
    'ARCHIVED_FILES:UNARCHIVE_REQUEST_SUCCESS': (state, { params }) => {
      const files = { ...state.entities.files }
      delete files[params.id]
      return {
        entities: { files },
        result: state.result.filter(id => id !== params.id)
      }
    }
  })
})

export default ArchivedFilesReducer
